/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const RemoteStart = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 20 26" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M15.27.5h-1.9A4 4 0 0 1 10 2.35 4 4 0 0 1 6.63.5h-1.9a4.29 4.29 0 0 0-4.4 4.14v16.72a4.29 4.29 0 0 0 4.4 4.14h10.54a4.29 4.29 0 0 0 4.4-4.14V4.64A4.29 4.29 0 0 0 15.27.5zm-6 6.55h1.48v6.07H9.26l.01-6.07zM10 19A5.87 5.87 0 0 1 6.1 8.68l1 1.1a4.4 4.4 0 1 0 5.84 0l1-1.1A5.87 5.87 0 0 1 10 19z" fillRule="nonzero" />
      </g>
    </svg>
  </span>
);

RemoteStart.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

RemoteStart.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default RemoteStart;
